export const VIEWER_MODELS = {
  "atlas-m": {
    label: "Atlas M",
    url: "/models/atlas-m-concept-v1.glb",
    exposure: 1.1,
    target: [0, 0.95, 0.03],
    views: {
      home: [2.6, 2.1, 3.8],
      front: [0, 1.25, 4.6],
      side: [4.5, 1.35, 0],
      back: [0, 1.35, -4.6],
    },
  },
  "atlas-r1": {
    label: "Atlas R1",
    url: "/models/atlas-r1-shell-off-v1.glb",
    exposure: 0.8,
    target: [0, 1.15, 0],
    lineArt: true,
    views: {
      home: [2.65, 1.85, 4.4],
      front: [0, 1.35, 4.65],
      side: [4.65, 1.35, 0],
      back: [0, 1.35, -4.65],
    },
    zones: [
      {
        id: "vision",
        label: "Vision",
        color: "#9bc6ff",
        nodes: ["05 Exposed head"],
        description:
          "Conceptual head-mounted sensing region; final sensor configuration is project-specific.",
      },
      {
        id: "arms",
        label: "Arms",
        color: "#95dec5",
        nodes: ["03 Left articulated", "04 Right articulated"],
        description:
          "Task-oriented arms and end effectors. This concept is not a kinematic or safety validation model.",
      },
      {
        id: "frame",
        label: "Frame",
        color: "#b5c9ff",
        nodes: ["02 Open column"],
        description:
          "Open support structure for arms, wiring and expansion. Dimensions and loads require engineering confirmation.",
      },
      {
        id: "base",
        label: "Base",
        color: "#edba89",
        nodes: ["01 Circular open"],
        description: "Conceptual mobile base layout, not live navigation or obstacle avoidance.",
      },
    ],
  },
  "fmg-imu": {
    label: "FMG + IMU",
    url: "/models/fmg-exterior-v1.glb",
    exposure: 1.05,
    target: [0, 0.54, 0],
    studio: true,
    lineArt: true,
    views: {
      home: [2.6, 3.5, 3.8],
      front: [0, 1.15, 5.3],
      side: [5.3, 1.5, 0],
      back: [0, 5.6, 0.01],
    },
  },
};
